export default __webpack_public_path__ + "static/Vicente-085311b2ebe835f3846e8ae80ac8a5da.jpg";